import React from "react";
import styled from "styled-components";
import ImgWrapper from "./ImgWrapper";
import { socialIcons } from "constants/post";

const Wrapper = styled.div`
  position: relative;
  width: ${({ size }) => (size ? size : "4.0")}rem;
  height: ${({ size }) => (size ? size : "4.0")}rem;

  .social-icon {
    position: absolute;
    bottom: 0;
    right: -8px;
    background-color: #fff;
    border-radius: 50%;
    padding: 4px;
    width: ${({ socialIconSize }) =>
      socialIconSize ? socialIconSize : "30px"};
    height: ${({ socialIconSize }) =>
      socialIconSize ? socialIconSize : "30px"};
  }
`;

/**
 * AvatarWithIcon component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.avatar - The URL of the avatar image.
 * @param {string} props.social - The social icon name.
 * @param {string | number} [props.size] - The size of the avatar and social icon.
 * @param {string} [props.className] - Props for extending styles.
 * @param {string | number} [props.socialIconSize] - The size
 * @returns {JSX.Element} The AvatarWithIcon component.
 */
const AvatarWithIcon = ({
  avatar,
  social,
  size,
  className,
  socialIconSize,
}) => {
  return (
    <Wrapper size={size} className={className} socialIconSize={socialIconSize}>
      <ImgWrapper size={size}>
        <img src={avatar} alt="user" />
      </ImgWrapper>
      <div className="social-icon flexRow alignCenter justifyCenter">
        <img src={socialIcons.circle[social]} alt="text" width="16px" />
      </div>
    </Wrapper>
  );
};

export default AvatarWithIcon;
